export const FAQ = [
  {
    id: 1,
    question: 'Сколько стоят ваши услуги?',
    answer: [{ text: 'Для собственника это бесплатно.' }],
  },
  {
    id: 2,
    question: 'Как быстро вы сдадите квартиру?',
    answer: [
      { text: 'В среднем находим жильцов за 8-10 дней — это быстрее, чем сдать самостоятельно.' },
      {
        text: 'Такие сроки мы получаем потому, что:',
        list: [
          'делаем профессиональные фото и текст объявления',
          'продвигаем объявление в топ поиска',
          'принимаем звонки и проводим показы с 10 до 21 ежедневно',
        ],
      },
      {
        text: 'Однако скорость также зависит от состояния квартиры, критериев к жильцам и размера арендной платы. Мы поможем оценить квартиру и предложим конкурентную цену.',
      },
    ],
  },
  {
    id: 3,
    question: 'Вы предоставляете свой договор аренды?',
    answer: [
      {
        text: 'Да, мы предлагаем договор, который составили и одобрили юристы. Он учитывает все нюансы законодательства и защищает интересы собственника. Но если вы захотите в нем что-то изменить, мы поможем составить правки и согласуем их с жильцом.',
      },
      {
        text: 'Шаблон договора аренды вы найдете на pik-arenda.ru',
      },
    ],
  },
  {
    id: 4,
    question: 'Зачем нужна страховка?',
    answer: [
      {
        text: 'Если с квартирой что-то случится, вы будете защищены от любых неожиданностей: жильцы затопят соседей, их кошка испортит обои или они съедут без предупреждения. Мы компенсируем ущерб и простой квартиры, пока ищем новых арендаторов.',
      },
      {
        text: 'А еще страховкой можно заменить депозит — это повысит привлекательность вашего объявления. Для собственника это бесплатно, страховые взносы включим в арендную плату вместо депозита.',
      },
    ],
  },
  {
    id: 5,
    question: 'Что такое дистанционные показы?',
    answer: [
      {
        text: 'Это удобный и безопасный способ показать квартиру без присутствия менеджера или собственника.',
      },
      {
        text: 'На время показов мы установим сейф с ключами и камеры в каждую комнату. С их помощью будем следить за квартирой и сопровождать кандидатов на просмотре. Они смогут познакомиться с квартирой в удобное время, а вы — посмотреть прямую трансляцию или записи прошедших показов.',
      },
      {
        text: 'В камерах есть датчик движения, они записывают видео со звуком 24/7 — мы первые узнаем о любой активности в квартире. Если потребуется, служба безопасности приедет и все проверит.',
      },
    ],
  },
  {
    id: 6,
    question: 'Я могу работать с вами и другими посредниками?',
    answer: [
      {
        text: 'Мы берем на себя весь цикл сдачи квартиры и работаем на эксклюзивных условиях — попросим снять объявления и не сотрудничать с риелторами/агентствами. Вы сможете полностью контролировать нашу работу через личный кабинет.',
      },
      {
        text: 'Отзывы жильцов показывают, что одно объявление от крупного сервиса вызывает больше доверия.',
      },
    ],
  },
  {
    id: 7,
    question: 'Как арендатор будет платить за квартиру?',
    answer: [
      {
        text: 'Арендатор оплачивает аренду напрямую собственнику в даты, которые установим в договоре.',
      },
      {
        text: 'Мы всегда будем рядом, чтобы помочь в случае задержки платежей или выезда жильца без предупреждения.',
      },
    ],
  },
  {
    id: 8,
    question: 'А если я уже сдаю квартиру?',
    answer: [
      {
        text: 'Вы всё равно сможете пользоваться всеми преимуществами ПИК-Аренды — достаточно подключиться к нашему сервису.  Услуга для вас бесплатна, а жилец оплатит номинальную сумму 10 рублей.',
      },
    ],
  },
];
